import { FactoryProvider, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceAlertButtonComponent } from './price-alert-button/price-alert-button.component';
import { PriceAlertViewComponent } from './price-alert-view/price-alert-view.component';
import { PriceAlertFormLayoutComponent } from './price-alert-form-layout/price-alert-form-layout.component';
import { PriceAlertComponent } from './price-alert/price-alert.component';
import { GeneralModule } from '../general/general.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {PriceAlertFormComponent} from './price-alert-form/price-alert-form.component';
import { PriceAlertsPageComponent } from './price-alerts-page/price-alerts-page.component';
import { PriceAlertsCoinsListComponent } from './price-alerts-coins-list/price-alerts-coins-list.component';
import { PaymentTypesModule } from '../payment-types/payment-types.module';
import { PriceAlertsPairsListComponent } from './price-alerts-pairs-list/price-alerts-pairs-list.component';
import { PriceAlertsPairDetailComponent } from './price-alerts-pair-detail/price-alerts-pair-detail.component';
import { PriceAlertFormControlService } from './service/price-alert-form-control.service';
import { AlertForm } from './service/alert-form/alert-form';
import { NumericAlertForm, PercentageDecreaseAlertForm, PercentageIncreaseAlertForm } from './service/alert-form';
import { PipesModule } from '../pipes/pipes.module';
import { PriceAlertsPairItemComponent } from './price-alerts-pair-item/price-alerts-pair-item.component';
import { NewPriceAlertButtonComponent } from './new-price-alert-button/new-price-alert-button.component';
import { PriceAlertItemComponent } from './price-alert-item/price-alert-item.component';

export function priceAlertFormControlServiceFactory(...alertForms: Array<AlertForm>): PriceAlertFormControlService {
  return new PriceAlertFormControlService(alertForms);
}

const AlertFormFactoryProvider: FactoryProvider = {
  provide: PriceAlertFormControlService,
  useFactory: priceAlertFormControlServiceFactory,
  deps: [
    NumericAlertForm,
    PercentageIncreaseAlertForm,
    PercentageDecreaseAlertForm
  ]
};

@NgModule({
  declarations: [
    PriceAlertButtonComponent,
    PriceAlertFormComponent,
    PriceAlertFormLayoutComponent,
    PriceAlertViewComponent,
    PriceAlertComponent,
    PriceAlertsPageComponent,
    PriceAlertsCoinsListComponent,
    PriceAlertsPairsListComponent,
    PriceAlertsPairDetailComponent,
    PriceAlertsPairItemComponent,
    NewPriceAlertButtonComponent,
    PriceAlertItemComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    NgxSliderModule,
    MatCheckboxModule,
    GeneralModule,
    MatSlideToggleModule,
    PaymentTypesModule,
    PipesModule,
  ],
  exports: [
    PriceAlertComponent,
    PriceAlertButtonComponent,
  ],
  providers: [
    NumericAlertForm,
    PercentageDecreaseAlertForm,
    PercentageIncreaseAlertForm,
    AlertFormFactoryProvider
  ]
})
export class PriceAlertModule { }
